import api from "@/config/http-client-gateway";
import { showErrorToast } from '@/kernel/alerts';

export const getPublicHistoryOperations = async (language) => {
    try {
        const params = {
            language: language,
        }
        const { data } = await api.doGet('/history-operation-by-language', { params });
        return data;
    } catch (error) {
        showErrorToast("Error al obtener el historial de operaciones");
        return error;
    }
}

export const getPublicFiles = async (section) => {
    try {
        const params = {
            category: section,
        }
        const { data } = await api.doGet('/public-files', { params });
        return data;
    } catch (error) {
        showErrorToast("Error al obtener los archivos");
        return error;
    }
}